import Collection from '../../Models/Collection';
import { Moments } from '../../Models/Moments';
import type { ReduxAction } from '../../types';

export interface MomentsState {
  collection: Collection<Moments>;
}

const initialMomentsState = {
  collection: new Collection<Moments>(),
};

export function momentsReducer(
  state: MomentsState = initialMomentsState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'FETCH_MOMENTS_REQUESTED':
      return {
        ...state,
        collection: state.collection.copyWith({
          items: state.collection.items.update(
            payload.id.toString(),
            new Moments({ isFetching: true }),
            (summary) => summary.copyWith({ isFetching: true }),
          ),
        }),
      };

    case 'FETCH_MOMENTS_SUCCEEDED':
      return {
        ...state,
        collection: state.collection.copyWith({
          items: state.collection.items.set(
            payload.requestID.toString(),
            new Moments(payload.response),
          ),
        }),
      };

    case 'FETCH_MOMENTS_FAILED':
    default:
      return state;
  }
}
